import { render, staticRenderFns } from "./BtnEmissoesBem.vue?vue&type=template&id=5f76f87d"
import script from "./BtnEmissoesBem.vue?vue&type=script&lang=js"
export * from "./BtnEmissoesBem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports